export default import.meta.ROLLUP_FILE_URL_TRlLm2Zz;